import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { createContext, useContext, useMemo, useState } from 'react';
var ChatWidgetContext = /*#__PURE__*/createContext([false, function () {}, false]);
export var ChatWidgetProvider = function ChatWidgetProvider(_ref) {
  var children = _ref.children;
  var state = useState(false);
  var value = useMemo(function () {
    return [].concat(_toConsumableArray(state), [false]);
  }, [state]);
  return /*#__PURE__*/React.createElement(ChatWidgetContext.Provider, {
    value: value
  }, children);
};
export var useChatWidget = function useChatWidget() {
  return useContext(ChatWidgetContext);
};